import React, { useEffect, useState } from "react";
import axios from 'axios'; // Import Axios
import '../news/blog.css'
import { Link } from "react-router-dom";
import Modal from 'react-modal'; // Import Modal component

function BlogUi() {
  const [posts, setPosts] = useState([]);
  const [error, setError] = useState(null); // State to hold error messages
  const [modalIsOpen, setModalIsOpen] = useState(false); // State to manage modal visibility
  const [selectedPost, setSelectedPost] = useState(null); // State to hold selected post details

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await axios.get('https://tita.itrain.io/blog/get'); // Use Axios to fetch data
        console.log("Fetched data:", response.data); // Log the fetched data
        if (response.data.success) {
          setPosts(response.data.blogs); // Set the posts state with the blogs array
          console.log(posts)
        } else {
          setError("Failed to fetch posts. Please try again later."); // Handle case where success is false
        }
      } catch (error) {
        console.error("Error fetching posts:", error.response ? error.response.data : error.message); // Log detailed error
        setError("Failed to fetch posts. Please try again later."); // Set error message
      }
    };

    fetchPosts();
  }, []);

  const openModal = (post) => { // Function to open modal with selected post
    setSelectedPost(post); // Set the selected post
    setModalIsOpen(true); // Open the modal
    document.body.style.overflow = 'hidden'; // Disable background scroll
  };

  const closeModal = () => { // Function to close modal
    setModalIsOpen(false);
    setSelectedPost(null);
    document.body.style.overflow = 'unset'; // Enable background scroll
  };
  const sharePost = (postId) => {
    const postUrl = `${window.location.origin}/Blog-details?id=${postId}`;
    if (navigator.share) {
      navigator.share({
        title: "Check out this blog post!",
        url: postUrl,
      }).catch((error) => console.error("Sharing failed:", error));
    } else {
      navigator.clipboard.writeText(postUrl);
      alert("Link copied to clipboard!");
    }
  };


  return (
    <>
      <main className="custom-blog-main custom-blog-wrapper">
        <div className="custom-blog-layout">
          {/* Display error message if there is an error */}
          {error && <div className="error-message">{error}</div>}
          
          {/* Blog posts */}
          <div className="custom-blog-posts">
            {posts.length > 0 &&
              posts.map(post => (
                <article key={post._id} className="custom-blog-article">
                  <header className="custom-blog-article-header">
                    <h2 className="custom-blog-article-title">{post.title}</h2>
                  </header>
                  <div className="custom-blog-article-content">
                    <img
                      src={post.image}
                      alt="Featured post image"
                      className="custom-blog-featured-image"
                    />
                  </div>
                  <footer className="custom-blog-article-footer">
                    <Link to={`/Blog-details?id=${post._id}`}>  <button className="custom-blog-button">Read More</button></Link>  {/* Updated button to redirect to post details */}
                    <button
  className="custom-blog-share-button"
  onClick={() => sharePost(post._id)}
  style={{
    border: '2px solid #FF001E',  // Border color
    padding: '10px 20px',          // Adjust the padding to fit the icon
    display: 'flex',               // To align the icon and text
    alignItems: 'center',          // Vertically center the icon and text
    gap: '8px',                    // Space between icon and text
    backgroundColor: 'transparent' // To make the background transparent (optional)
  }}
>
  <i className="fas fa-share-alt" style={{ color: '#FF001E' }}></i> {/* Example icon, change to your preferred */}
  Share
</button>
                  </footer>
                </article>
              ))
           }
          </div>

     

          {/* Sidebar */}
          <aside className="custom-blog-sidebar">
            <div className="custom-blog-article">
              <header className="custom-blog-article-header">
                <h3 className="custom-blog-article-title">Search</h3>
              </header>
              <div className="custom-blog-article-content">
                <input type="text" placeholder="Search posts..." className="custom-blog-search" />
              </div>
            </div>

            <div className="custom-blog-article">
              <header className="custom-blog-article-header">
                <h3 className="custom-blog-article-title">Categories</h3>
              </header>
              <div className="custom-blog-article-content">
                <span className="custom-blog-category">React</span>
                <span className="custom-blog-category">JavaScript</span>
                <span className="custom-blog-category">CSS</span>
                <span className="custom-blog-category">Web Design</span>
                <span className="custom-blog-category">Performance</span>
              </div>
            </div>
          </aside>
        </div>
      </main>
    </>
  )
}
export default BlogUi